/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
import React, { Component, useEffect } from 'react';

import './styles.css';

import logo from '../../assets/image/logo.png'
import gerence from '../../assets/image/GerenceLogo.png'



class Home extends Component {

    constructor(props) {
        

        super(props);
        
        
        window.scrollTo(0, 0);

        // Alterar essa variavel para False para poder testar no celular colocando apenas o IP
        let producao = true;

        if (!producao) {
            this.props.history.push({ pathname: "/?nomeEmpresa=gerence" });
        }

    }

    
    render() {           
        return (
            <>
                <div className='d-flex align-items-center justify-content-center' style={{ width: 'auto', height: '100vh' }}>
                    <div className='d-flex flex-column'>
                        {/* <img src={logo} alt='Comer Aqui' className='m-auto' style={{ width: '80%', height: 'auto' }}/> */}
                        <div className='d-flex flex-column mt-5'>
                            <small className='text-muted'>desenvolvido por</small>
                            <a href='http://www.gerencesistemas.com.br' target='_blank' noreferer=''>
                                <img src={gerence} alt='Gerence Sistemas' className='m-auto' />
                            </a>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Home;
